export default function BlogButton({ children }) {
    return (
        <button
            type="button"
            className="!no-underline inline-flex px-4 py-2 rounded-full text-sm !text-white caret-white bg-blue-600 hover:bg-blue-500"
        >
            {children}
        </button>
    );
}